import CircleCheckmarkOutlineIcon from "@src/lib/icons/18px/circle-checkmark-outline";
import EditUserTypeDialog from "@src/features/users/dialogs/EditUserTypeDialog";
import InlineEditButton from "@src/lib/ui/InlineEditButton";
import InlineEditField from "@src/lib/ui/InlineEditField";
import useActionPermissions from "@src/features/app/hooks/useActionPermissions";
import useUser from "@src/features/app/hooks/useUser";
import { UserType } from "@src/types.generated";
import { FC, useMemo, useState } from "react";
import { UserDetailsAdminEmployeeFragment } from "@src/features/users/user-details/UserDetails.generated";

type Props = {
  user: UserDetailsAdminEmployeeFragment;
};

export const userTypeOptions = [
  { value: UserType.Admin, label: "Admin" },
  { value: UserType.Manager, label: "Manager" },
  { value: UserType.Employee, label: "Trainee" },
];

export const getUserTypeLabel = (userType: UserType): string => {
  return userTypeOptions.filter((option) => option.value === userType)[0].label;
};

const EditUserType: FC<Props> = ({ user }) => {
  const { user: currentUser } = useUser();
  const { userActionPermissions } = useActionPermissions();
  const [editTypeOpen, setEditTypeOpen] = useState(false);
  const canEditUserType = useMemo(() => {
    if (user.id === currentUser?.id) {
      return false;
    }
    if (userActionPermissions?.changeOrgSettings) {
      return true;
    }
    return (
      userActionPermissions?.promoteTrainees &&
      user.userType === UserType.Employee
    );
  }, [
    user.id,
    user.userType,
    currentUser?.id,
    userActionPermissions?.changeOrgSettings,
    userActionPermissions?.promoteTrainees,
  ]);

  return (
    <>
      <InlineEditField
        icon={<CircleCheckmarkOutlineIcon className="size-4" />}
        label="User type"
        labelStyle={{ width: 160 }}
        valueStyle={{ flex: 1 }}
      >
        {!canEditUserType ? (
          <InlineEditButton
            values={[getUserTypeLabel(user.userType)]}
            loading={user === undefined}
          />
        ) : (
          <InlineEditButton
            values={[getUserTypeLabel(user.userType)]}
            onClick={() => setEditTypeOpen(true)}
          />
        )}
      </InlineEditField>
      <EditUserTypeDialog
        open={editTypeOpen}
        onOpenChange={setEditTypeOpen}
        user={user}
      />
    </>
  );
};

export default EditUserType;
